/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2025 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * DownLoad Styles
 *
 * @file DownLoadStyles.js
 * @author Mohamed yasar arabath M
 * @since 3.0.22
 */

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import mixins from '../../../assets/styles/mixins.scss';

export const DownloadRoot = styled(Button)({
  '&&': {
    width: '100%',
    height: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 'unset',

    '& span': {
      minWidth: 'unset'
    }
  }
});

export const DownloadWrapper = styled('div')({
  '&&': {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px'
  }
});

export const DownloadIconPlaceholder = styled('div', {
  shouldForwardProp: (prop) => prop !== 'showProgress'
})(({ showProgress }) => ({
  '&&': {
    minWidth: 'unset',
    borderRadius: '48px',
    background: showProgress ? mixins.whiteFont : mixins.swatchLightFont,
    display: 'inline-flex',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    boxSizing: 'border-box',
    alignSelf: 'center',
    color: showProgress ? mixins.swatchPrimary : undefined,
    position: showProgress ? 'relative' : undefined,
    '& svg': {
      width: showProgress ? 48 : 24,
      height: showProgress ? 48 : 24,
      alignSelf: 'center'
    },

    '&:hover': {
      backgroundColor: showProgress ? mixins.whiteFont : mixins.swatchLightFont
    }
  }
}));

export const DownloadTitle = styled('span')({
  '&&': {
    color: mixins.chalkWhiteFont,
    textAlign: 'center',
    fontFeatureSettings: '\'liga\' off, \'clig\' off',
    fontFamily: mixins.fontFamilyTT,
    fontSize: mixins.fontSize14,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight400,
    lineHeight: '16px',
    letterSpacing: '0.24px'
  }
});

export const DownloadProgressText = styled('span')({
  '&&': {
    position: 'absolute',
    top: 17,
    color: mixins.darkThemeColor,
    fontFamily: mixins.fontFamilyPOP,
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: 'normal',
    letterSpacing: '-0.2px'
  }
});
